const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_BANK_ACCOUNTS': {
      return {
        ...state,
        apiCalled: false,
        bankAccounts: action.data,
      };
    }
    case 'SEARCH_BANKS': {
      return {
        ...state,
        apiCalled: true,
      };
    }
    case 'SEARCH': {
      return {
        ...state,
        bankAccounts: {},
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
